export var IUninstallReason;
(function (IUninstallReason) {
    IUninstallReason["NO_REASON"] = "no_reason";
    IUninstallReason["TECHNICAL_ISSUE"] = "technical_issue";
    IUninstallReason["BAD_INTERFACE"] = "bad_interface";
    IUninstallReason["LIMITED_FEATURES"] = "limited_features";
    IUninstallReason["SWITCHING_TO_ANOTHER_APP"] = "switching_to_another_app";
    IUninstallReason["TEMPORARY_UNINSTALLATION"] = "temporary_uninstallation";
})(IUninstallReason || (IUninstallReason = {}));
